import {type DefaultError, useQuery, type UseQueryOptions, type UseQueryResult} from "@tanstack/react-query";
import type {UrlQueryKey} from "./queryClient";

/**
 * Same as useQuery with {@link UrlQueryKey} as the default query key type (matches defaultQueryFn).
 */
export function useCustomQuery<
    TQueryFnData = unknown,
    TError = DefaultError,
    TData = TQueryFnData,
    TQueryKey extends UrlQueryKey = UrlQueryKey,
>(
    options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): UseQueryResult<TData, TError> {
    return useQuery(options);
}
